import React, { useState } from 'react';
import LandingPage from './components/LandingPage';
import UploadPage from './components/UploadPage';
import ResponsePage from './components/ResponsePage';
import './App.css';

function App() {
  const [step, setStep] = useState(1);
  const [result, setResult] = useState(null);

  const handleResponse = (data) => {
    setResult(data);
    setStep(3);
  };

  const handleRetake = () => {
    setResult(null);
    setStep(2); // Go to UploadPage only, not LandingPage
  };

  return (
    <div className="app-container">
      {step === 1 && <LandingPage onStart={() => setStep(2)} />}
      {step === 2 && <UploadPage onSuccess={handleResponse} />}
      {step === 3 && result &&<ResponsePage
  dob={result?.dob}
  age={result?.age}
  error={result?.error}
  message={result?.message}
  errorType={result?.errorType}
  onRetake={handleRetake}
/>}
    </div>
  );
}

export default App;
